module.exports = __webpack_public_path__ + "952d892c0e2f5a78d0856e8ca255d87c.pdf";